import { ClearanceContent } from "../../components/adjustment";

export default function InvoiceClearance() {
  return <ClearanceContent />;
}
